import { render, staticRenderFns } from "./VideoItem2.vue?vue&type=template&id=0a77f5e9&scoped=true"
import script from "./VideoItem2.vue?vue&type=script&lang=js"
export * from "./VideoItem2.vue?vue&type=script&lang=js"
import style0 from "./VideoItem2.vue?vue&type=style&index=0&id=0a77f5e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a77f5e9",
  null
  
)

export default component.exports